import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Wraps the routed content and triggers a 150ms fade-in animation each time
 * the pathname changes. The `key` prop forces a clean remount, so the CSS
 * animation re-runs on every navigation. Honors `prefers-reduced-motion`.
 */
export default function PageTransition({ children }) {
  const location = useLocation();
  return (
    <div key={location.pathname} className="page-fade">
      {children}
    </div>
  );
}
